import React from 'react'

import PaginationCard from './Components/PaginationCard'
import PerPage from './Components/PerPage'
import NumberOfItems from './Components/NumberOfItems'

function Pagination() {
  return (
    <div className="col-12">
      <div className="metaverse-pagination-new">
        <NumberOfItems />
        <PaginationCard />
        <PerPage />
      </div>
    </div>
  )
}

export default Pagination
